import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=656c67cc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=656c67cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c67cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656c67cc')) {
      api.createRecord('656c67cc', component.options)
    } else {
      api.reload('656c67cc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=656c67cc&scoped=true&", function () {
      api.rerender('656c67cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2v43YzHtgGuYy/JS/comp/SearchFilterTokens.vue"
export default component.exports